import { render, staticRenderFns } from "./BookingRevenueReport.vue?vue&type=template&id=21148e48&scoped=true"
import script from "./BookingRevenueReport.vue?vue&type=script&lang=js"
export * from "./BookingRevenueReport.vue?vue&type=script&lang=js"
import style0 from "./BookingRevenueReport.vue?vue&type=style&index=0&id=21148e48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21148e48",
  null
  
)

export default component.exports